import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb0f1ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduce-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title black" }, "情况说明", -1))
const _hoisted_3 = { class: "detail-desc grey" }
const _hoisted_4 = { class: "desc-item-box" }
const _hoisted_5 = { class: "desc-item" }
const _hoisted_6 = { class: "black" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grey" }, "资金来源", -1))
const _hoisted_8 = { class: "desc-item" }
const _hoisted_9 = { class: "black" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grey" }, "业务类型", -1))
const _hoisted_11 = { class: "desc-item" }
const _hoisted_12 = { class: "black" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grey" }, "工程类型", -1))
const _hoisted_14 = { class: "desc-item" }
const _hoisted_15 = { class: "black" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grey" }, "经营方式", -1))
const _hoisted_17 = {
  key: 0,
  class: "desc-line row"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "项目地址：", -1))
const _hoisted_19 = { class: "black" }
const _hoisted_20 = { class: "desc-line row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "联系人员：", -1))
const _hoisted_22 = { class: "row contact" }
const _hoisted_23 = { class: "black" }
const _hoisted_24 = { class: "blue" }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode("点击拨打")
const _hoisted_27 = { class: "card-box" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "detail-title black" }, "人员配置")
], -1))
const _hoisted_29 = { class: "grey" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "设计总师", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode()
const _hoisted_32 = { class: "black" }
const _hoisted_33 = { class: "grey" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "工程总师", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode()
const _hoisted_36 = { class: "black" }
const _hoisted_37 = { class: "grey" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "项目成员", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode()
const _hoisted_40 = { class: "black" }
const _hoisted_41 = { class: "card-box" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "detail-title black" }, "其他信息")
], -1))
const _hoisted_43 = { class: "grey" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "招标方式", -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode()
const _hoisted_46 = { class: "black" }
const _hoisted_47 = { class: "grey" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "招标机构", -1))
const _hoisted_49 = /*#__PURE__*/_createTextVNode()
const _hoisted_50 = { class: "black" }
const _hoisted_51 = { class: "grey" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "归属区域", -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode()
const _hoisted_54 = { class: "black" }
const _hoisted_55 = { class: "grey" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "业务类型", -1))
const _hoisted_57 = /*#__PURE__*/_createTextVNode()
const _hoisted_58 = { class: "black" }
const _hoisted_59 = { class: "grey" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "申报人", -1))
const _hoisted_61 = /*#__PURE__*/_createTextVNode()
const _hoisted_62 = { class: "black" }
const _hoisted_63 = { class: "grey" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "协作人", -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode()
const _hoisted_66 = { class: "black" }
const _hoisted_67 = { class: "grey" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "介绍人", -1))
const _hoisted_69 = /*#__PURE__*/_createTextVNode()
const _hoisted_70 = { class: "grey" }
const _hoisted_71 = { class: "grey" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "申报单位", -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode()
const _hoisted_74 = { class: "black" }
const _hoisted_75 = { class: "grey" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-width" }, "申报时间", -1))
const _hoisted_77 = /*#__PURE__*/_createTextVNode()
const _hoisted_78 = { class: "black" }

import { useRouter } from 'vue-router'
import { ProjectData } from '@/apis/projectList'
// import { getItemDetail } from '@/apis/projectDetail'
// import { Toast } from 'vant'


export default /*#__PURE__*/_defineComponent({
  props: {
  projectData: {
    type: Object,
    default: {} as ProjectData
  }
},
  setup(__props) {

const props = __props

// import { onActivated, onMounted, reactive, ref, watch } from 'vue'


const router = useRouter()
// const to_log = () => {
//   router.push('projectFollowLog?project_name=' + props.projectData.name + '&project_id=' + props.projectData.id)
// }
// const to_cost = () => {
//   router.push('costAccounting?project_name=' + props.projectData.name + '&project_id=' + props.projectData.id)
// }
// const to_collect = () => {
//   router.push('fileCollect?project_name=' + props.projectData.name + '&project_id=' + props.projectData.id)
// }
// const to_contract = () => {
//   if (props.projectData.contract) {
//     router.push('contract?project_name=' + props.projectData.name + '&project_id=' + props.projectData.id)
//   } else {
//     Toast('暂无项目合同')
//   }
// }
// const to_plan = () => {
//   router.push('deliverPlan?project_name=' + props.projectData.name + '&project_id=' + props.projectData.id)
// }
// // 项目验收
// const to_acceptance = async () => {
//   // const get_Acceptance = async () => {
//   let data = {
//     type: 8,
//     project_id: props.projectData.id
//   }
//   const res = await getItemDetail(data)
//   if (res.code === 200) {
//     console.log(res.data)
//     if (res.data.approve && res.data.approve.state === 1) {
//       let data1 = JSON.stringify(res.data)
//       router.push('acceptance-info?data=' + data1 + '&type_name=项目验收')
//     } else {
//       Toast('项目暂未验收')
//     }
//   }
// }

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.projectData.inspection_instructions), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.projectData.capital_source_desc), 1),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(__props.projectData.declare_type_name || '暂无'), 1),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(__props.projectData.project_type == 1 ? '新建' : '改造'), 1),
          _hoisted_13
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(__props.projectData.mode_operation_descs || '暂无'), 1),
          _hoisted_16
        ])
      ]),
      (__props.projectData.province)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, _toDisplayString(`${__props.projectData.province.name} ${__props.projectData.city.name} ${__props.projectData.area.name}`), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(__props.projectData.contact_name) + "（" + _toDisplayString(__props.projectData.contact_phone) + "）", 1),
          _createElementVNode("span", _hoisted_24, [
            _createElementVNode("a", {
              class: "blue",
              href: 'tel:' + __props.projectData.contact_phone
            }, [
              _hoisted_26,
              _createVNode(_component_van_icon, { name: "phone-circle" })
            ], 8, _hoisted_25)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _hoisted_31,
        _createElementVNode("span", _hoisted_32, _toDisplayString(__props.projectData?.design_staff?.name || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _hoisted_35,
        _createElementVNode("span", _hoisted_36, _toDisplayString(__props.projectData?.engrg_staff?.name || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _hoisted_39,
        _createElementVNode("span", _hoisted_40, _toDisplayString(__props.projectData?.canyu_staffs_names || '暂无'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _hoisted_42,
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _hoisted_45,
        _createElementVNode("span", _hoisted_46, _toDisplayString(__props.projectData?.tender_name || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _hoisted_49,
        _createElementVNode("span", _hoisted_50, _toDisplayString(__props.projectData?.tender_organ_name || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _hoisted_53,
        _createElementVNode("span", _hoisted_54, _toDisplayString(__props.projectData?.belong_area_name || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_55, [
        _hoisted_56,
        _hoisted_57,
        _createElementVNode("span", _hoisted_58, _toDisplayString(__props.projectData?.declare_type_descs || '暂无'), 1)
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _hoisted_61,
        _createElementVNode("span", _hoisted_62, _toDisplayString(__props.projectData.staff?.name || '无'), 1)
      ]),
      _createElementVNode("div", _hoisted_63, [
        _hoisted_64,
        _hoisted_65,
        _createElementVNode("span", _hoisted_66, _toDisplayString(__props.projectData.collaboration_staff_name || '无'), 1)
      ]),
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        _hoisted_69,
        _createElementVNode("span", _hoisted_70, _toDisplayString(__props.projectData.introduce_staff_name || '无'), 1)
      ]),
      _createElementVNode("div", _hoisted_71, [
        _hoisted_72,
        _hoisted_73,
        _createElementVNode("span", _hoisted_74, _toDisplayString(__props.projectData.staff.cf_name), 1)
      ]),
      _createElementVNode("div", _hoisted_75, [
        _hoisted_76,
        _hoisted_77,
        _createElementVNode("span", _hoisted_78, _toDisplayString(__props.projectData.created_at), 1)
      ])
    ])
  ]))
}
}

})